import React from 'react'
import { useRegistrationForm } from '../../hooks/useRegistrationForm';
import { RegistrationFields } from '../../models/registration-fields';

type FieldLabelProps = {
    field: keyof RegistrationFields;
    label: string | undefined;
};

export const FieldLabel: React.FC<FieldLabelProps> = ({ field, label }: FieldLabelProps) => {
    const { getFieldRequirement } = useRegistrationForm();
    return (
        <label
            htmlFor={field}
            className="form-label"
        >
            {label}
            {getFieldRequirement(field) === "required" && (
                <span className="required-dot">*</span>
            )}
        </label>
    )
};